import React, { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { authStatuses, permissionsStatuses } from './util/constants';

const LoadSubscribe = lazy(() => import('./LoadSubscribe'));

const mapStateToProps = ({ appData: { userData, permissions } }) => {
   return { shouldPreload: false };

   if (
      userData.status !== authStatuses.authenticated ||
      permissions.status !== permissionsStatuses.loaded
   ) {
      return { shouldPreload: false };
   }

   let isSubscribed = false;
   const subData = permissions?.subscriptionAndPurchases?.subscription;
   if (subData) {
      if (
         new Date(subData.expiration) > Date.now() &&
         subData.includes.includes('exercise')
      ) {
         isSubscribed = true;
      }
   }

   if (isSubscribed) {
      return { shouldPreload: false };
   }
   return { shouldPreload: true };
};

const LazyLoadSubscribe = connect(mapStateToProps)(({ shouldPreload }) => {
   if (shouldPreload) {
      return (
         <Suspense fallback={null}>
            <LoadSubscribe />
         </Suspense>
      );
   }
   return null;
});

export { LazyLoadSubscribe };
